import React from 'react'

export default function Logo({ mini }) {
	if (mini) {
		return <img src="/assets/images/logo-mini.png" alt="logo image" />
	}

	return <img src="/assets/images/logo-mini.png" alt="logo image" />
}
